export const SHA256_HEX = /^[a-f0-9]{64}$/;
export const HISTORY_OWNER = /^user-[a-f0-9]{64}$/;

export function historyOwner(subject: string): string {
  return `user-${subject}`;
}
